(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
      if(gallery.dataset.ready)return;
      gallery.dataset.ready='true';
      const select=id=>{
        if(!id||![...gallery.querySelectorAll('[data-gallery-slide]')].some(slide=>slide.dataset.gallerySlide===id))return;
        gallery.querySelectorAll('[data-gallery-slide]').forEach(slide=>slide.hidden=slide.dataset.gallerySlide!==id);
        gallery.querySelectorAll('[data-gallery-select]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.gallerySelect===id)));
      };
      gallery.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-select]');if(button)select(button.dataset.gallerySelect);});
      const thumbs=gallery.querySelector('.product-thumbnails');
      const move=direction=>{
        const buttons=[...gallery.querySelectorAll('[data-gallery-select]')];
        const current=buttons.findIndex(button=>button.getAttribute('aria-pressed')==='true');
        const next=buttons[Math.max(0,Math.min(buttons.length-1,current+direction))];
        if(next){select(next.dataset.gallerySelect);thumbs.scrollTo({left:next.offsetLeft-thumbs.offsetLeft-(thumbs.clientWidth-next.clientWidth)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
      };
      gallery.querySelector('[data-thumbnails-prev]')?.addEventListener('click',()=>move(-1));
      gallery.querySelector('[data-thumbnails-next]')?.addEventListener('click',()=>move(1));
      gallery.closest('[data-product-section]')?.querySelector('[data-variant-select]')?.addEventListener('change',event=>select(event.target.selectedOptions[0]?.dataset.galleryImage));
    });
    root.querySelectorAll('[data-reviews]').forEach(section => {
      if(section.dataset.ready)return;
      section.dataset.ready='true';
      const track=section.querySelector('.review-grid'), cards=[...track.children];
      const prev=section.querySelector('[data-review-prev]'), next=section.querySelector('[data-review-next]'), count=section.querySelector('[data-review-position]');
      const index=()=>Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/track.clientWidth)));
      const update=()=>{const i=index();prev.disabled=i===0;next.disabled=i===cards.length-1;count.textContent=`${i+1} / ${cards.length}`;};
      const move=delta=>track.scrollTo({left:Math.max(0,Math.min(cards.length-1,index()+delta))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
      let width=track.clientWidth, selected=0;
      track.addEventListener('scroll',()=>selected=index(),{passive:true});
      new ResizeObserver(()=>{if(width!==track.clientWidth){width=track.clientWidth;track.scrollLeft=selected*width;update();}}).observe(track);
      update();
    });
  };
  initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.querySelectorAll('.review-submit-form').forEach(form=>{
    const body=form.querySelector('[name="comment[body]"]'), rating=form.querySelector('[data-review-rating]');
    const previous=body.value.match(/^\[([1-5])\/5\]\s*/);
    if(previous){rating.value=previous[1];body.value=body.value.slice(previous[0].length);}
    form.addEventListener('submit',()=>{body.value=`[${rating.value}/5] ${body.value.replace(/^\[[1-5]\/5\]\s*/,'').trim()}`;});
  });
  document.querySelectorAll('[data-product-section]').forEach(section=>{
    const variants=JSON.parse(section.querySelector('[data-offer-variants]')?.textContent||'[]');
    if(!variants.length)return;
    const form=section.querySelector('.product-form');
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:window.Shopify?.currency?.active||'AUD'}).format(cents/100);
    const primary=form.querySelector('[name="id"]');
    const choices=form.querySelector('[data-bundle-choices]');
    const selects=[...form.querySelectorAll('[data-bundle-variant]')];
    const resolve=id=>variants.find(v=>String(v.id)===String(id));
    const fullPrice=quantity=>selects.length&&quantity>1
      ? selects.slice(0,quantity).reduce((sum,select)=>sum+(resolve(select.value)?.price||0),0)
      : (resolve(primary.value)?.price||0)*quantity;
    const refresh=()=>{
      const variant=resolve(primary.value);
      if(!variant)return;
      const quantity=Number(form.querySelector('[name="quantity"]:checked')?.value||1);
      if(choices){
        choices.hidden=quantity===1;
        selects.forEach((select,index)=>{
          select.disabled=quantity===1||index>=quantity;
          select.closest('[data-bundle-choice]').hidden=index>=quantity;
        });
      }
      section.querySelectorAll('[data-offer-price]').forEach(price=>{
        const full=fullPrice(Number(price.dataset.quantity)), total=full-Math.floor(full*(1-Number(price.dataset.rate))+0.000001);
        price.replaceChildren();
        const strong=document.createElement('strong');strong.textContent=money(total);price.append(strong);
        if(total<full){const old=document.createElement('s');old.textContent=money(full);price.append(old);}
      });
      section.querySelectorAll('[data-offer-unit]').forEach(unit=>{
        const quantity=Number(unit.dataset.quantity),full=fullPrice(quantity);
        const total=full-Math.floor(full*(1-Number(unit.dataset.rate))+0.000001);
        unit.textContent=money(Math.round(total/quantity))+' '+unit.dataset.label;
      });
    };
    const syncPrimary=()=>selects.forEach((select,index)=>{
      if(index===0||!select.dataset.chosen)select.value=primary.value;
    });
    form.addEventListener('change',event=>{
      if(event.target===primary)syncPrimary();
      if(event.target.matches('[data-bundle-variant]')){
        event.target.dataset.chosen='true';
        if(event.target===selects[0]&&primary.value!==event.target.value){
          primary.value=event.target.value;
          primary.dispatchEvent(new Event('change',{bubbles:true}));
        }
      }
      refresh();
    });
    syncPrimary();refresh();
  });
  const businessDaysAfter=(start,days)=>{
    const date=new Date(start);
    while(days>0){date.setUTCDate(date.getUTCDate()+1);if(date.getUTCDay()!==0&&date.getUTCDay()!==6)days--;}
    return date;
  };
  const delivery=()=>{
    const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Australia/Brisbane',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const part=name=>parts.find(p=>p.type===name).value;
    const today=new Date(`${part('year')}-${part('month')}-${part('day')}T12:00:00Z`);
    const format=date=>new Intl.DateTimeFormat('en-AU',{timeZone:'UTC',day:'numeric',month:'short'}).format(date);
    document.querySelectorAll('[data-delivery-timeline]').forEach(timeline=>{
      timeline.querySelector('[data-delivery-today]').textContent=format(today);
      timeline.querySelector('[data-delivery-dispatch]').textContent=format(businessDaysAfter(today,1));
      timeline.querySelector('[data-delivery-arrival]').textContent=format(businessDaysAfter(today,7))+' – '+format(businessDaysAfter(today,9));
    });
  };
  delivery();setInterval(delivery,60000);
  const recent=document.querySelector('[data-recent-products]');
  if(recent){try{
    const key='hushly-recent-products';
    const saved=JSON.parse(localStorage.getItem(key)||'[]');
    const handles=Array.isArray(saved)?saved.filter(h=>typeof h==='string'):[];
    const current=recent.dataset.current;
    const grid=recent.querySelector('[data-recent-grid]');
    handles.filter(h=>h!==current).slice(0,4).forEach(handle=>{const template=[...recent.querySelectorAll('template')].find(t=>t.dataset.handle===handle);if(template)grid.append(template.content.cloneNode(true));});
    recent.hidden=!grid.children.length;
    localStorage.setItem(key,JSON.stringify([current,...handles.filter(h=>h!==current)].slice(0,12)));
  }catch{recent.hidden=true;}}
})();
